module.exports = __webpack_public_path__ + "img/5.0186d581.jpg";